const sliderWrapper = document.querySelector('.bundle-wrapper')
const slides = sliderWrapper?.querySelectorAll('.bundle')
const cartButton = document.querySelector(".bundle-cart-button")
const prevArrow = document.querySelector('.prev')
const nextArrow = document.querySelector('.next')
const stickyATCButton = document.querySelector("button.sticky-atc")

if (!prevArrow || !nextArrow) {
	console.warn('Navigation arrows not found')
	// Continue execution as the arrows might be intentionally hidden
}

// Toggle Arrows
if (slides.length > 1) {
	prevArrow.classList.remove("hidden")
	nextArrow.classList.remove("hidden")
}

if (slides.length > 1) {
	let currentSlideIndex = 0

	function updateSliderPosition() {
		sliderWrapper.style.transform = `translateX(-${currentSlideIndex * 100}%)`
	}

	// Reusable function to handle the visibility and behavior of the arrows
	function updateArrowsState() {
		// Disable or enable the arrows based on the current slide index
		if (currentSlideIndex === 0) {
			prevArrow.classList.add("no__events")
			nextArrow.classList.remove("no__events")
		} else if (currentSlideIndex === slides.length - 1) {
			nextArrow.classList.add("no__events")
			prevArrow.classList.remove("no__events")
		} else {
			prevArrow.classList.remove("no__events")
			nextArrow.classList.remove("no__events")
		}

		// Update the cart button's data attribute based on the current slide
		const currentSlideCartButton = document.querySelectorAll("#cart-button")[currentSlideIndex]
        updateVariantId(cartButton, currentSlideCartButton)
		updateBundleCartButton(slides[currentSlideIndex], currentSlideCartButton, cartButton)

		slides.forEach(slide => slide.classList.remove("active")) // Remove the active class from all slides
		slides[currentSlideIndex].classList.add("active") // Add the active class to the current slide
	}

	// Event listener for the previous arrow
	prevArrow.addEventListener('click', () => {
		if (currentSlideIndex > 0) {
			currentSlideIndex--
			updateSliderPosition()
		}
		updateArrowsState()
	})

	// Event listener for the next arrow
	nextArrow.addEventListener('click', () => {
		if (currentSlideIndex < slides.length - 1) {
			currentSlideIndex++
			updateSliderPosition()
		}
		updateArrowsState()
	})

	// Initialize arrow states based on the current slide index
	updateArrowsState()
} else {
	const currentSlideCartButton = document.querySelector(".bundle #cart-button")
	updateVariantId(cartButton, currentSlideCartButton)
	updateBundleCartButton(slides[0], currentSlideCartButton, cartButton)
	slides[0].classList.add("active")
}

// Function to update the bundle cart buttons based on swatch availability
function updateBundleCartButton(currSlide, currentSlideCartButton, bundleCartButton) {
	const availableSwatch = [...currSlide.querySelectorAll(".bundle-product-swatch")]
		.find(swatch => !swatch.getAttribute("disabled"))

	const buttons = [currentSlideCartButton, bundleCartButton]

	buttons.forEach(button => {
		if (!button) return

		const isButton = button.tagName === "BUTTON"

		if (availableSwatch) {
			if (isButton) {

				if (!stickyATCButton.hasAttribute("disabled")) {
					button.removeAttribute("disabled")
					button.querySelector("span").textContent = "Make it a bundle"
				}
			} else {
				button.removeAttribute("disabled")
			}
		} else {
			button.setAttribute("disabled", "true")
			if (isButton) button.querySelector("span").textContent = window.variantStrings.soldOut
		}
	})
}

// Function to updateVarinatID
function updateVariantId(ele1, ele2) {
	if (ele1 && ele2) {
		ele1.setAttribute("data-variant-id", ele2.getAttribute("data-variant-id"))

		// Set active bundle's bundle name to bundle cart button which will be used to apply discount to the bundle
		const bundleName = ele2.getAttribute("data-bundle-name")
		if (bundleName) ele1.setAttribute("data-bundle-name", bundleName)
	}
}

// Variant picker function
// Utility function to log and remove the selected class from swatches
function selectSwatch(swatch, bundle) { 
	const swatches = bundle.querySelectorAll(".bundle-product-swatch")
	swatches.forEach(item => item.classList.remove("selected", "unavailable"))
	swatch.classList.add("selected")
}

// Utility function to get the variant value from the select boxes
function getVariantValue(parentElement) {
	const selectBoxes = parentElement.querySelectorAll(".select_box select")
	const variantArray = []
	let variantValue = ""

	if (selectBoxes.length > 0) {
		selectBoxes.forEach(select => {
			variantArray.push(select.value)
		})

		variantValue = variantArray.join("-")
	}

	return variantValue // Return the full variant value
}

// Utility function to check variants and update the swatch and form input
function updateVariant(swatch, variantValue) {
	const parentElement = swatch.closest(".bundle")
	const variants = parentElement.querySelectorAll(".variants-value p")

	if (variants.length > 0) {
		variants.forEach(variant => {
			const value = variant.getAttribute("data-variant-value")

			if (value && value === variantValue) {

				const variantId = variant.getAttribute("data-variant-id")
				swatch.setAttribute("data-variant-id", variantId)

				const bundleWrapper = swatch.closest(".bundle")
			
				if (bundleWrapper) {
					const formInput = bundleWrapper.querySelector(".bundle_form input.product-variant-id")
					const bundleCartButton = document.querySelector(".bundle-cart-button")
					const price = bundleWrapper.querySelector(".bundle-product-price")
					const currentSlideCartButton = bundleWrapper.querySelector("#cart-button")
					
					price.innerHTML = variant.getAttribute("data-price")

					if (formInput && bundleCartButton && currentSlideCartButton)  {
						const buttons = [bundleCartButton, currentSlideCartButton]

						buttons.forEach(button => {
							button.dataset.variantId = variantId
						})
						
						formInput.value = variantId

						// Set active bundle's discount value toproduct form which will be used to apply discount to the bundle.
						const bundleName = currentSlideCartButton.getAttribute("data-bundle-name")
						const productForm = formInput.closest("product-form")

						if (productForm && bundleName) productForm.setAttribute("data-bundle-name", bundleName)
					}
				}
			}
		})
	}
}

// Function to handle swatch click event
function handleSwatchClick(swatch) {
	const optionLabel = swatch.getAttribute("data-option")

	if (optionLabel) {
		const parentElement = swatch.closest(".bundle")
		const variantValue = getVariantValue(parentElement) !== "" ? getVariantValue(parentElement) + "-" + optionLabel : optionLabel

		selectSwatch(swatch, parentElement)
		updateVariant(swatch, variantValue)
	}
}

// Function to handle select box change event
function handleSelectBoxChange(select) {
	const parentElement = select.closest(".bundle")
	const selectedSwatch = parentElement.querySelector(".bundle-product-swatch.selected")

	initializeVariants(parentElement, select)

	if (selectedSwatch) {
		const optionLabel = selectedSwatch.getAttribute("data-option")

		if (optionLabel) {
			const variantValue = getVariantValue(parentElement) !== "" ? getVariantValue(parentElement) + "-" + optionLabel : optionLabel
			updateVariant(selectedSwatch, variantValue)
		}
	}
}

// Initialize event listeners
function initializeEvents() {
	const bundles = document.querySelectorAll('.bundle')
	const swatches = document.querySelectorAll(".bundle-product-swatch")
	const selectBoxes = document.querySelectorAll(".select_box select")

	// getQuantityArray(bundles)

	if (bundles.length > 0) {
		bundles.forEach(bundle => {
			initializeVariants(bundle)
		})
		updateBundleCartButton(bundles[0], bundles[0].querySelector("#cart-button"), cartButton)
	}

	if (swatches.length > 0) {
		swatches.forEach(swatch => {
			if (!swatch.hasAttribute("disabled")) swatch.addEventListener("click", () => handleSwatchClick(swatch))
		})
	}

	if (selectBoxes.length > 0) {
		selectBoxes.forEach(select => {
			select.addEventListener("change", () => handleSelectBoxChange(select))
		})
	}
}

// Initialize the event listeners when the document is ready
document.addEventListener("DOMContentLoaded", initializeEvents)


function initViewMoreButton(viewMoreButtonsSelector, bundlePopupSelector) {
	const viewMoreButtons = document.querySelectorAll(viewMoreButtonsSelector)

	if (viewMoreButtons.length === 0) return

	viewMoreButtons.forEach(button => {
		button.addEventListener('click', () => handleViewMoreClick(button, bundlePopupSelector))
	})
}

function handleViewMoreClick(button, bundlePopupSelector) {
	const bundle = button.closest('.bundle')
	const bundleVariantContainer = bundle.querySelector('.bundle-product-variants')
	const swatches = bundleVariantContainer.querySelectorAll('.bundle-product-swatch')
	const bundlePopup = document.querySelector(bundlePopupSelector)
	const overlay = document.querySelector(".background-overlay")

	if (!bundlePopup) return

	togglePopupVisibility(bundlePopup, overlay, false)
	populatePopupContent(bundle, bundleVariantContainer, bundlePopup, overlay)
	initializeSwatches(bundleVariantContainer, swatches, bundlePopup)
}

function togglePopupVisibility(bundlePopup, overlay, hide) {
	bundlePopup.classList.toggle('hide-visibility', hide)
	overlay.classList.toggle("hidden", hide)
	document.body.classList.toggle("overflow-hidden", !hide)
}

function populatePopupContent(bundle, bundleVariantContainer, bundlePopup, overlay) {
	const swatchContainer = bundlePopup.querySelector('.bundle-variant-picker')
	swatchContainer.innerHTML = bundleVariantContainer.innerHTML

	const closeButton = bundlePopup.querySelector('.close')
	if (closeButton) {
		closeButton.addEventListener('click', () => togglePopupVisibility(bundlePopup, overlay, true))
	}

	const chooseVariant = bundlePopup.querySelector(".choose-variant")
	loadingSpinner(chooseVariant, bundlePopup, overlay)

	const bundleProductDetails = {
		image: bundle.querySelector('.bundle-product-image img'),
		title: bundle.querySelector('.bundle-product-title')
	}

	const productImage = bundlePopup.querySelector('.product_content img')
	const productTitle = bundlePopup.querySelector('.product_content .title')

	if (bundleProductDetails.image && productImage) productImage.src = bundleProductDetails.image.src
	if (productTitle && bundleProductDetails.title) productTitle.textContent = bundleProductDetails.title.textContent
}

function initializeSwatches(bundleVariantContainer, swatches, bundlePopup) {
	const swatchContainer = bundlePopup.querySelector('.bundle-variant-picker')
	const bundleSwatches = swatchContainer.querySelectorAll('.bundle-product-swatch')

	bundleSwatches.forEach((swatch, index) => {
		swatch.classList.remove('tw-hidden')
		swatch.querySelector('.swatch-label')?.classList.remove('tw-hidden')

		swatch.addEventListener('click', () => {
			bundleSwatches.forEach(ele => ele.classList.remove('selected'))
			swatch.classList.add('selected')
			swatches[index].click()
		})
	})
}

function loadingSpinner(button, popup, overlay) {
	const spinner = button.querySelector('.loading__spinner')

	const toggleLoadingState = (isLoading) => {
		button.classList.toggle('loading', isLoading)
		spinner?.classList.toggle('hidden', !isLoading)
	};

	button.addEventListener('click', () => {
		toggleLoadingState(true)

		setTimeout(() => {
			toggleLoadingState(false)
			popup.classList.add("hide-visibility")
			overlay.classList.add("hidden")
			document.body.classList.remove("overflow-hidden")
		}, 1200)
	});
}

// Call the function with your specific selectors
initViewMoreButton(".bundle .view-more", ".bundle-variant_picker_popup");


function initializeVariants(bundle, select) {
	const selectBox1 = bundle.querySelector(".select_box1 select");
	const selectBox2 = bundle.querySelector(".select_box2 select");
	const swatches = bundle.querySelectorAll(".bundle-product-swatch");

	// Get the selected value from the first select input
	const selectedOption1 = selectBox1 ? selectBox1.value : null;
	const selectedOption2 = select && select.parentElement.classList.contains("select_box2") ? select : null

	if (selectedOption1) {
		// Fetch all the variants matching the selected option1 value
		const variants = bundle.querySelectorAll(`.variants-value p[data-option1="${selectedOption1}"]`);

		if (variants.length > 0) {
			if (selectedOption2) {
				let filteredVariants = filterSecondOption(variants, selectedOption2)

				if (filteredVariants.length > 0) {
					const availableSwatches = new Set(); 

					filteredVariants.forEach(variant => {
						let	swatchValue = variant.getAttribute("data-option3");
						availableSwatches.add(swatchValue);
					})

					if (swatches.length > 0) updateElements(swatches, availableSwatches, 'data-option');
					updateSwatches(bundle)
				}

			} else {
				// Create sets for available option2 values and swatch data
				const availableOption2 = new Set();
				const availableSwatches = new Set();

				// Loop through all variants and track available option2 and swatches
				processVariants(variants, availableOption2, availableSwatches, selectBox2);

				// Update options and swatches based on available values
				if (selectBox2) {
					const options = selectBox2.querySelectorAll('option');

					options?.forEach(option => option.removeAttribute("selected"))
					updateElements(options, availableOption2, 'value', true);
				}
				if (swatches.length > 0) updateElements(swatches, availableSwatches, 'data-option');
				updateSwatches(bundle)
			}
		}
	} else {
		updateSwatches(bundle)
	}
}

function filterSecondOption(variants, select) {
	const filteredVariants = Array.from(variants).filter(variant => variant.getAttribute('data-option2') === select.value)
	return filteredVariants
}

// General function to update any select box options or swatches
function updateElements(elements, availableValues, attributeName, updateOption) {
	let updateFirstOption = updateOption

	elements.forEach(element => {
		const value = element.getAttribute(attributeName);
		if (!availableValues.has(value)) {
			element.setAttribute("disabled", "true");
		} else {
			if (updateFirstOption) {
				element.setAttribute("selected", "true")
				updateFirstOption = false
			}
			element.removeAttribute("disabled");
		}
	});
}

// This processes all the variants to gather available option values
function processVariants(variants, availableOption2, availableSwatches, selectBox) {
	variants.forEach(variant => {
		const option2 = variant.getAttribute("data-option2");
		let swatchValue;

		if (selectBox) {
			swatchValue = variant.getAttribute("data-option3");
			availableOption2.add(option2);
		} else {
			swatchValue = option2;
		}

		availableSwatches.add(swatchValue);
	});
}

function updateSwatches(bundle) {
    const selectBox1 = bundle.querySelector(".select_box1 select");
    const selectBox2 = bundle.querySelector(".select_box2 select");
    const swatches = bundle.querySelectorAll(".bundle-product-swatch");
    const unAvailableSwatches = new Set();
    const availableSwatches = new Set();
    const otherSwatches = new Set();

    const getVariants = (option1, option2 = '') => {
        const selector = option1
            ? `.variants-value p[data-option1="${option1}"]${option2 ? `[data-option2="${option2}"]` : ''}`
            : '.variants-value p';
        return bundle.querySelectorAll(selector);
    };

    const processVariants = (dataValue, option1, option2) => {
        getVariants(option1, option2).forEach(variant => {
            const value = variant.getAttribute(dataValue);
            const isAvailable = variant.getAttribute("data-available") !== "false";
            isAvailable ? availableSwatches.add(value) : unAvailableSwatches.add(value);
            otherSwatches.add(option2 ? variant.getAttribute("data-option3") : variant.getAttribute("data-option2"));
        });
    };

    const updateSwatchAttributes = () => {
        swatches.forEach(swatch => {
            const value = swatch.getAttribute("data-option");
            if (unAvailableSwatches.has(value) || !availableSwatches.has(value)) {
                swatch.setAttribute("disabled", "true");
            }
			if (availableSwatches.has(value)) {
				swatch.removeAttribute("disabled");
			}
        });

		const firstAvailableSwatch = Array.from(swatches).find(swatch => availableSwatches.has(swatch.getAttribute("data-option")));
		const availableSwatchesArray = Array.from(swatches).filter(swatch => availableSwatches.has(swatch.getAttribute("data-option")));

		// if (firstAvailableSwatch && firstAvailableSwatch.getAttribute("disabled") !== "true") {
		// 	handleSwatchClick(firstAvailableSwatch);
		// }

		if (availableSwatchesArray.length > 0) {
			let element = null

			for (const swatch of availableSwatchesArray) {
				if (swatch.getAttribute("disabled") !== "true" && swatch.classList.contains("selected")) {
					element = swatch
				}
			}

			handleSwatchClick(element ? element : availableSwatchesArray[0])
		}
    };

    const option1Value = selectBox1 ? selectBox1.value : null;
    const option2Value = selectBox2 ? selectBox2.value : null;

    if (option1Value) {
        const dataValue = option2Value ? "data-option3" : "data-option2";
        processVariants(dataValue, option1Value, option2Value);
    } else {
        processVariants("data-option1");
    }

    updateSwatchAttributes();
}